module.exports = __webpack_public_path__ + "static/media/chillWARE_Live.830952ec.png";